import { render } from "./Division.vue?vue&type=template&id=448ded26"
import script from "./Division.vue?vue&type=script&lang=js"
export * from "./Division.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__